import UploadFormSiteUnsubscribeFile from '../../../pages/clients/avion/UploadFormSiteUnsubscribeFile.vue';

export default [
  { // MLD-4339
    path: '/v2/admin/clients/avion/formsite/unsubscribe',
    name: 'avion.formsite.unsubscribe',
    component: UploadFormSiteUnsubscribeFile,
  }
]
